import { render, staticRenderFns } from "./RiderCommission.vue?vue&type=template&id=d61b2a9a&"
import script from "./RiderCommission.vue?vue&type=script&lang=js&"
export * from "./RiderCommission.vue?vue&type=script&lang=js&"
import style0 from "./RiderCommission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports